module.exports = __webpack_public_path__ + "r-3.png?21c0b92063d82d016c049dcde521313d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/r-3.png
// module id = 62
// module chunks = 0